import { render, staticRenderFns } from "./attachmentForm.vue?vue&type=template&id=36c20622&"
import script from "./attachmentForm.vue?vue&type=script&lang=js&"
export * from "./attachmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports